module.exports = __webpack_public_path__ + "static/media/logout.61ece3d4.png";